angular.module('impactx.userdialog').controller('UserSettingsCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToolbarService',
    'ToastService',
    'TranslationService',
    'PartialDialogsService',
    UserSettingsCtrl
]);

function UserSettingsCtrl ($scope, dataGen, $routeParams, BackService, ToolbarService, ToastService, TranslationService,
                           PartialDialogsService) {
    var userId = $routeParams.id;
    $scope.productmenu = {menuitems: [{label: 'Placeholder', view: 'lobby'}]};
    $scope.showToolbar = false;
    $scope.toggleToolbar = function () {
        $scope.showToolbar = !$scope.showToolbar;
    };
    $scope.getPageData = function () {
        dataGen.getData($scope, {id: userId}, "/user/settings/view", function () {
            defineButtons();
        });
    };
    $scope.getPageData();

    $scope.savePageData = function ($event, showOthers) {
        var data = $scope.data;
        var dataObj = {
            data: data
        };

        return dataGen.post($scope, dataObj, "/user/settings/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if(showOthers)
            {
                PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.USER, userId, 'usersettings', undefined, true);
            }
            else
            {
                PartialDialogsService.addDialog(PartialDialogsService.TYPE.USER, userId, 'usersettings');
                PartialDialogsService.redirectToList(PartialDialogsService.TYPE.USER, undefined);
            }
        });
    };

    $scope.savePageDataBackToList = function ($event) {
        return $scope.savePageData($event, false)
    };

    $scope.savePageDataOtherDialogs = function ($event) {
        return $scope.savePageData($event, true)
    };

    function valueFunction() {
        return $scope.data && $scope.data.userCard && $scope.data.userCard.maxNumberOfUsersReached
            && !$scope.data.userCard.canSaveWithMaxNumberOfUsersReached;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageDataBackToList,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            },
            {
                label: $scope.trns.saveAndForward,
                action: $scope.savePageDataOtherDialogs,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}